"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_FRTRAD = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#FFF5F5" },
          100: { value: "#FED7D7" },
          200: { value: "#FDB2B3" },
          300: { value: "#FD8181" },
          400: { value: "#FC5F60" },
          500: { value: "#EE3031" },
          600: { value: "#C9292A" },
          700: { value: "#A32122" },
          800: { value: "#8A1C1D" },
          900: { value: "#651515" },
        },
        secondary: {
          50: { value: "#FFF5F5" },
          100: { value: "#FED7D7" },
          200: { value: "#FDB2B3" },
          300: { value: "#FD8181" },
          400: { value: "#FC5F60" },
          500: { value: "#EE3031" },
          600: { value: "#C9292A" },
          700: { value: "#A32122" },
          800: { value: "#8A1C1D" },
          900: { value: "#651515" },
        },
      },
    },
  },
});
